type Theme = 'light' | 'dark';

interface ChartColors {
  textColor: string;
  gridColor: string;
  crosshairColor: string;
  crosshairLabelBg: string;
  upColor: string;
  upColorBorder: string;
  upColorWick: string;
  downColor: string;
  downColorBorder: string;
  downColorWick: string;
  priceLineColor: string;
  priceLineLabelColor: string;
  priceLineLabelTextColor: string;
  profitLineColor: string;
  profitTopColor: string;
  profitBottomColor: string;
  lossLineColor: string;
  lossTopColor: string;
  lossBottomColor: string;
  loadingOverlay: string;
}

const darkColors: ChartColors = {
  textColor: 'rgba(255,255,255,0.35)',
  gridColor: 'rgba(255,255,255,0.04)',
  crosshairColor: 'rgba(249,115,22,0.3)',
  crosshairLabelBg: 'rgba(249,115,22,0.85)',
  upColor: 'rgba(52,211,153,0.8)',
  upColorBorder: 'rgba(52,211,153,0.9)',
  upColorWick: 'rgba(52,211,153,0.5)',
  downColor: 'rgba(248,113,113,0.8)',
  downColorBorder: 'rgba(248,113,113,0.9)',
  downColorWick: 'rgba(248,113,113,0.5)',
  priceLineColor: 'rgba(96,165,250,0.8)',
  priceLineLabelColor: 'rgba(96,165,250,1)',
  priceLineLabelTextColor: '#fff',
  profitLineColor: 'rgba(34,197,94,0.9)',
  profitTopColor: 'rgba(34,197,94,0.25)',
  profitBottomColor: 'rgba(34,197,94,0.02)',
  lossLineColor: 'rgba(239,68,68,0.9)',
  lossTopColor: 'rgba(239,68,68,0.25)',
  lossBottomColor: 'rgba(239,68,68,0.02)',
  loadingOverlay: 'rgba(0,0,0,0.4)',
};

const lightColors: ChartColors = {
  textColor: 'rgba(0,0,0,0.4)',
  gridColor: 'rgba(0,0,0,0.06)',
  crosshairColor: 'rgba(249,115,22,0.3)',
  crosshairLabelBg: 'rgba(249,115,22,0.85)',
  upColor: 'rgba(5,150,105,0.85)',
  upColorBorder: 'rgba(5,150,105,0.95)',
  upColorWick: 'rgba(5,150,105,0.5)',
  downColor: 'rgba(220,38,38,0.85)',
  downColorBorder: 'rgba(220,38,38,0.95)',
  downColorWick: 'rgba(220,38,38,0.5)',
  priceLineColor: 'rgba(37,99,235,0.8)',
  priceLineLabelColor: 'rgba(37,99,235,1)',
  priceLineLabelTextColor: '#fff',
  profitLineColor: 'rgba(5,150,105,0.9)',
  profitTopColor: 'rgba(5,150,105,0.15)',
  profitBottomColor: 'rgba(5,150,105,0.02)',
  lossLineColor: 'rgba(220,38,38,0.9)',
  lossTopColor: 'rgba(220,38,38,0.15)',
  lossBottomColor: 'rgba(220,38,38,0.02)',
  loadingOverlay: 'rgba(255,255,255,0.5)',
};

export function getChartColors(theme: Theme): ChartColors {
  return theme === 'dark' ? darkColors : lightColors;
}
